/**
 * Vérification bcrypt (version simplifiée de bcryptjs)
 * Ne gère que compareSync, pas la génération de hash.
 */
import * as bcrypt from 'bcryptjs';

export class BcryptVerifier {
  static compare(password: string, hash: string): boolean {
    // Remplace $2y$ par $2a$ car bcryptjs ne supporte pas $2y$
    if (hash.startsWith('$2y$')) {
      hash = '$2a$' + hash.substring(4);
    }
    return bcrypt.compareSync(password, hash);
  }
}
